/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { CancellationReasonResponse, GetCancellationReasonsParams } from './api.schemas';

import { api } from '../util/http';

export const getCancellationReasons = (
  params?: GetCancellationReasonsParams,
  signal?: AbortSignal,
) => {
  return api<CancellationReasonResponse[]>({
    url: `/api/cancellation-reasons`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetCancellationReasonsQueryKey = (params?: GetCancellationReasonsParams) => {
  return [`/api/cancellation-reasons`, ...(params ? [params] : [])] as const;
};

export const getGetCancellationReasonsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCancellationReasons>>,
  TError = unknown,
>(
  params?: GetCancellationReasonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCancellationReasons>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCancellationReasonsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCancellationReasons>>> = ({ signal }) =>
    getCancellationReasons(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCancellationReasons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCancellationReasonsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCancellationReasons>>
>;
export type GetCancellationReasonsQueryError = unknown;

export function useGetCancellationReasons<
  TData = Awaited<ReturnType<typeof getCancellationReasons>>,
  TError = unknown,
>(
  params: undefined | GetCancellationReasonsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCancellationReasons>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCancellationReasons>>,
          TError,
          Awaited<ReturnType<typeof getCancellationReasons>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCancellationReasons<
  TData = Awaited<ReturnType<typeof getCancellationReasons>>,
  TError = unknown,
>(
  params?: GetCancellationReasonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCancellationReasons>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCancellationReasons>>,
          TError,
          Awaited<ReturnType<typeof getCancellationReasons>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCancellationReasons<
  TData = Awaited<ReturnType<typeof getCancellationReasons>>,
  TError = unknown,
>(
  params?: GetCancellationReasonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCancellationReasons>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetCancellationReasons<
  TData = Awaited<ReturnType<typeof getCancellationReasons>>,
  TError = unknown,
>(
  params?: GetCancellationReasonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCancellationReasons>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCancellationReasonsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
